import type { AnchorStrategyModel } from '@/shared/generated'

import { MasterTable } from '@/shared/components/master-table'

import { useStrategiesTable } from '../../lib/useStrategiesTable'

export default function StrategiesTable({
	data,
}: {
	data: AnchorStrategyModel[]
}) {
	const table = useStrategiesTable(data)

	return <MasterTable table={table} />
}
